import { COLOURS } from "../data/colours";

/**
 * Injects SVG feColorMatrix filters that remap black -> Dulux target colour
 * while preserving white. Mount ONCE at the root of pages that render tinted
 * product images.
 *
 * feColorMatrix per-channel affine: out = (1 - t) * in + t
 * When in = 0 (black) => out = t (the target colour)
 * When in = 1 (white) => out = 1 (stays white)
 */
export default function ColourFilters() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="0"
      height="0"
      style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
    >
      <defs>
        {COLOURS.filter((c) => c.filter && c.target).map((c) => {
          const [tr, tg, tb] = c.target;
          const matrix = [
            1 - tr, 0, 0, 0, tr,
            0, 1 - tg, 0, 0, tg,
            0, 0, 1 - tb, 0, tb,
            0, 0, 0, 1, 0,
          ].join(" ");
          return (
            <filter
              id={c.filter}
              key={c.filter}
              colorInterpolationFilters="sRGB"
            >
              <feColorMatrix type="matrix" values={matrix} />
            </filter>
          );
        })}
      </defs>
    </svg>
  );
}
